module.exports = __webpack_public_path__ + "img/download-image-320.1ccff71e.svg";